import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiService, AdminLoginRequest } from '../services/api';
import './Auth.css';

const AdminLogin: React.FC = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const loginData: AdminLoginRequest = {
        email: formData.email,
        password: formData.password
      };

      await apiService.adminLogin(loginData);
      navigate('/admin/dashboard');
    } catch (err: any) {
      setError(err.message || 'Admin login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-logo">
            <span className="logo-icon">💰</span>
            <h1>RokdaHisab</h1>
          </div>
          <h2>Admin Login</h2>
          <p>Sign in to access admin dashboard</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {error && (
            <div className="error-message">
              <span className="error-icon">⚠️</span>
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Enter admin email"
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="Enter admin password"
              className="form-input"
            />
          </div>

          <button 
            type="submit" 
            className="auth-button"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner"></span>
                Signing in...
              </>
            ) : (
              <>
                <span>Sign In</span>
                <span className="button-icon">→</span>
              </>
            )}
          </button>
        </form>
      </div>

      <div className="auth-background">
        <div className="floating-shapes">
          <div className="shape shape-1">💳</div>
          <div className="shape shape-2">📊</div>
          <div className="shape shape-3">💰</div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;

